module.exports = __webpack_public_path__ + "img/go-lang.0bc7b57f.png";